import React, { useState, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import '../Testimonials/styles.css';
import { ReactComponent as IconoFlechaI } from '../../../assets/Svg/IconoFlechaI.svg';
import { ReactComponent as IconoFlechaD } from '../../../assets/Svg/IconoFlechaD.svg';
import { ReactComponent as VectorA } from '../../../assets/Svg/VectorA.svg';
import { ReactComponent as Google } from '../../../assets/Svg/Google.svg';
import ItacaWideBlack from '../../../assets/fonts/itaca/Itaca Wide Black.ttf';
import ItacaWideBold  from '../../../assets/fonts/itaca/Itaca-Wide-Bold.otf';
import ItacaWideDemiBold from '../../../assets/fonts/itaca/Itaca-Wide-DemiBold.otf';
import AlbertSansRegular from '../../../assets/fonts/Albert_Sans/AlbertSans-Regular.ttf';

// Inyecta todas las fuentes directamente
const fontStyles = `
@font-face {
  font-family: 'Itaca-Wide-Black';
  src: url(${ItacaWideBlack}) format('truetype');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-Bold';
  src: url(${ItacaWideBold}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-DemiBold';
  src: url(${ItacaWideDemiBold}) format('opentype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

  @font-face {
  font-family: 'Albert-Sans-Regular';
  src: url(${AlbertSansRegular}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
/* Agrega más @font-face para otras variantes si es necesario */
`;

// Crea y añade el elemento style al head
const styleElement = document.createElement('style');
styleElement.innerHTML = fontStyles;
document.head.appendChild(styleElement); 


// Importación optimizada de imágenes
const userImages = [
  require('../../../assets/Imagenes/Planes_Futuro/user1.jpg'),
  require('../../../assets/Imagenes/Planes_Futuro/user2.jpg'),
  require('../../../assets/Imagenes/Planes_Futuro/user3.jpg'),
  require('../../../assets/Imagenes/Planes_Futuro/user4.jpg'),
  require('../../../assets/Imagenes/Planes_Futuro/user5.jpg')
];

const Testimonials = ({ testimonios = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Función para formatear la fecha
  const formatDate = (relativeTime) => {
    if (!relativeTime) return "2025-01-20";
    
    // Convertir relativeTimeDescription a formato YYYY-MM-DD
    const today = new Date();
    const match = relativeTime.match(/Hace (\d+) (mes|semana|día)/);
    
    if (match) {
      const [_, amount, unit] = match;
      const date = new Date(today);
      
      if (unit === 'mes') {
        date.setMonth(date.getMonth() - parseInt(amount));
      } else if (unit === 'semana') {
        date.setDate(date.getDate() - (parseInt(amount) * 7));
      } else if (unit === 'día') {
        date.setDate(date.getDate() - parseInt(amount));
      }
      
      return date.toISOString().split('T')[0];
    }
    
    return "2025-01-20";
  };

  // Función para formatear los testimonios
  const formatTestimonials = (apiTestimonials) => {
    return apiTestimonials.map((testimonio, index) => ({
      id: index + 1,
      name: testimonio.authorName || `Usuario ${index + 1}`,
      quote: testimonio.text || "Excelente servicio, muy recomendable.",
      photoUrl: testimonio.profilePhotoUrl || userImages[index % userImages.length],
      rating: testimonio.rating || 5,
      date: formatDate(testimonio.relativeTimeDescription)
    }));
  };

  // Testimonios formateados (máximo 5)
  const formattedTestimonials = testimonios.length > 0 
    ? formatTestimonials(testimonios.slice(0, 5))
    : [
        {
          id: 1,
          name: "Karla Ruiz",
          quote: "Me encuentro demasiado agradecida con sus atenciones, una gran elección y sumamente recomendable.",
          photoUrl: userImages[0],
          rating: 5,
          date: "Hace 1 mes"
        },
        {
          id: 2,
          name: "Stephani Villa",
          quote: "Me encuentro demasiado agradecida con sus atenciones, una gran elección y sumamente recomendable.",
          photoUrl: userImages[1],
          rating: 4,
          date: "Hace 2 semanas"
        },
        {
          id: 3,
          name: "Carlos Perez",
          quote: "Excelente servicio, muy profesional y atentos.",
          photoUrl: userImages[2],
          rating: 5,
          date: "Hace 3 días"
        }
      ];

  const getVisibleTestimonials = useCallback(() => {
    const total = formattedTestimonials.length;
    if (window.innerWidth <= 900) {
      // En móvil: mostrar solo 1 testimonio (el actual)
      return [formattedTestimonials[currentIndex],
    formattedTestimonials[(currentIndex + 1) % total]];
    } else {
      // En desktop: mostrar 3 testimonios (anterior, actual y siguiente)
      return [
        formattedTestimonials[(currentIndex - 1 + total) % total],
        formattedTestimonials[currentIndex],
        formattedTestimonials[(currentIndex + 1) % total]
      ];
    }
  }, [currentIndex, formattedTestimonials]);

  const nextTestimonial = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % formattedTestimonials.length);
  }, [formattedTestimonials.length]);

  const prevTestimonial = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + formattedTestimonials.length) % formattedTestimonials.length);
  }, [formattedTestimonials.length]);

  const goToTestimonial = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  // Función para mostrar estrellas de rating
  const renderRatingStars = (rating) => {
    return (
      <div className="rating-stars">
        {[...Array(5)].map((_, i) => (
          <span key={i} className={i < rating ? 'star-filled' : 'star-empty'}>
            {i < rating ? '★' : '☆'}
          </span>
        ))}
      </div>
    );
  };

  // Función reutilizable para Typography
  const renderTypography = (text, options = {}) => (
    <Typography
      component={options.component || 'p'}
      color={options.color || '#000000'}
      fontSize={options.fontSize || '18px'}
      fontFamily={options.fontFamily || '"Albert Sans", sans-serif'}
      lineHeight={options.lineHeight || '100%'}
      sx={{
        '@media (max-width: 480px)': {
          fontSize: options.mobileFontSize || (options.fontSize === '42px' ? '32px' : '16px')
        },
        ...options.sx
      }}
      {...options}
    >
      {text}
    </Typography>
  );

  return (
    <>
      <section className="testimonials-section" aria-labelledby="testimonials-heading">
        <h2 id="testimonials-heading">
          {renderTypography("Testimonios", {
            component: "h2",
            fontSize: '42px',
            mobileFontSize: '25px !important',
            fontFamily: "'Itaca-Wide-Bold', sans-serif !important",
          })}
        </h2>
        
        <div className="testimonial-carousel">
          <div className="testimonials-group">
            {getVisibleTestimonials().map((testimonial, index) => (
              <div 
                key={`testimonial-${testimonial.id}`}
                className={`testimonial-item ${window.innerWidth > 900 ? 
                  (index === 1 ? 'active-testimonial' : '') : 
                  'active-testimonial'}`}
                aria-hidden={window.innerWidth > 900 ? index !== 1 : false}
              >
                <div className="testimonial-head">
                  <img 
                    src={testimonial.photoUrl} 
                    alt={`Foto de ${testimonial.name}`}
                    className="user-icon"
                    loading="lazy"
                  />
                  <div className="user-info">
                    {renderTypography(testimonial.name, {
                      color: '#D14081',
                      fontSize: '18px',
                      mobileFontSize: '18px !important',
                      fontFamily: 'AlbertBold, sans-serif !important'
                    })}
                     <span className="testimonial-date">{testimonial.date}</span>
                  </div>
                  <Google className="google-icon"/>
                </div>
                
                <div className="testimonial-meta">
                  {renderRatingStars(testimonial.rating)}
                  <VectorA className="vector-icon"/>
                </div>
                
                <div className="testimonial-text">
                  {renderTypography(`"${testimonial.quote}"`, {
                    fontSize: '15px',
                    mobileFontSize: '16px !important',
                    fontFamily: "'Albert-Sans-Regular', sans-serif !important",
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="indicators-container">
        <div className="indicators" role="tablist">
          <button 
            className="nav-button prev" 
            onClick={prevTestimonial}
            aria-label="Testimonio anterior"
          >
            <IconoFlechaI className="nav-icon" />
          </button>
          <div className="indicators-dot">
            {formattedTestimonials.map((_, index) => (
              <button
                key={`indicator-${index}`}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToTestimonial(index)}
                role="tab"
                aria-label={`Ir al testimonio ${index + 1}`}
                aria-selected={index === currentIndex}
              />
            ))}
          </div>
          <button 
            className="nav-button next" 
            onClick={nextTestimonial}
            aria-label="Siguiente testimonio"
          >
            <IconoFlechaD className="nav-icon" />
          </button>
        </div>
      </div>
    </>
  );
};

export default React.memo(Testimonials);